export default __webpack_public_path__ + "static/media/Le_Cachalot_Laurent_Rioux.2332e14a.jpg";